import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const EditWPadding = (props: Icon): React.ReactElement => (
  <svg
    style={{ ...style(props.size, props.height), ...props.style }}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <path
        d="M9.333 7.333a.667.667 0 01.078 1.33l-.078.004h-2a2 2 0 00-1.996 1.882l-.004.118v6a2 2 0 001.883 1.996l.117.004h6a2 2 0 001.997-1.883l.003-.117v-2a.667.667 0 011.33-.078l.004.078v2a3.334 3.334 0 01-3.19 3.33l-.144.003h-6a3.334 3.334 0 01-3.33-3.189L4 16.667v-6a3.334 3.334 0 013.189-3.33l.144-.004h2zm6.534-2.624a2.42 2.42 0 113.424 3.424l-1.466 1.466a.68.68 0 01-.005.004l-.005.004-5.222 5.223a.667.667 0 01-.184.13l-.106.04-3.455.975a.667.667 0 01-.823-.823L9 11.697c.03-.11.09-.21.17-.29l5.222-5.222a.68.68 0 01.005-.005l.004-.005zm-.999 2.885l-4.633 4.633-.604 2.141 2.142-.604 4.632-4.633-1.537-1.537zm3.48-1.942a1.087 1.087 0 00-1.538 0l-.999.999 1.537 1.537 1-.998c.37-.37.418-.937.145-1.358l-.075-.103z"
        id="edit_w_padding_a"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="edit_w_padding_b" fill="#fff">
        <use xlinkHref="#edit_w_padding_a" />
      </mask>
      <use fill="#FFF" fillRule="nonzero" xlinkHref="#edit_w_padding_a" />
      <g
        mask="url(#edit_w_padding_b)"
        fill={props.color || theme.palette.grey600}
      >
        <path d="M0 0h24v24H0z" />
      </g>
    </g>
  </svg>
);
